import { DateRange, DateRangePicker } from '@branch-messenger/willow-ui'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { formatISO } from 'date-fns'
import { useMemo } from 'react'

import { featureEnabled } from '@/lib/feature-flag'
import { getDateRangeFromPreset } from '@/lib/filter-helpers'

const dateFilterEnabled = featureEnabled('VITE_DATE_FILTERS_ENABLED')

export const DateFilter = () => {
  const navigate = useNavigate()

  const searchParams = useSearch({
    strict: false,
  })

  const { to, from, preset } = useMemo(() => {
    const { datePreset, fromDate, toDate } = searchParams
    return getDateRangeFromPreset({
      to: toDate,
      from: fromDate,
      presetId: datePreset,
    })
  }, [searchParams])

  const handleDateRangeChange = (range: DateRange) => {
    const from = range.presetId ? undefined : range.from
    const to = range.presetId ? undefined : range.to

    navigate({
      to: '.',
      search: {
        fromDate: from ? formatISO(from) : undefined,
        toDate: to ? formatISO(to) : undefined,
        datePreset: range.presetId,
      },
    })
  }

  if (!dateFilterEnabled) {
    return null
  }

  return (
    <DateRangePicker
      from={from || undefined}
      to={to || undefined}
      presetId={preset?.id}
      onSelect={handleDateRangeChange}
    />
  )
}
